import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {TYPE} from '../../models/type.enum';

declare var jQuery: any;

@Component({
  selector: 'cmp-nav-top',
  template: `<nav class="navbar navbar-{{type}} bg-white fixed-top">
  <div class="navbar-brand pt-0">
    <a class="cursor-pointer visible-mobile">
      <img src="./assets/images/brand/imgtype_blueliv.svg" alt="Blueliv" height="24" class="">
    </a>
    <img src="./assets/images/brand/logotype_blueliv_black.svg" alt="Blueliv" height="20" class="visible-desktop">
    <span class="version-app  hidden-xs"> v {{version}}</span>
  </div>
  <div class="menu-right">

    <div class="float-left">

      <ng-content></ng-content>
    </div>

    <button class="btn btn-light text-danger rounded-circle border btn-sm float-right" (click)="powerClick.emit(null)">
      <i class="fa fa-power-off"></i>
    </button>

    <div class="nav-menu-buttons visible-desktop" *ngIf="templateMenuDesktop">
      <ng-container *ngTemplateOutlet="templateMenuDesktop"></ng-container>
    </div>
    <div class="nav-menu-buttons visible-mobile" *ngIf="templateMenuMobile">
      <ng-container *ngTemplateOutlet="templateMenuMobile"></ng-container>
    </div>
  </div>
</nav>

`,
  styles: [`.rounded-circle{width:31px}.navbar{box-shadow:0 1px 3px rgba(0,0,0,.12),0 1px 2px rgba(0,0,0,.24);height:54px}.navbar .navbar-brand{margin-left:40px}.navbar .version-app{position:absolute;top:35px;left:86px;font-size:10px}.navbar .btn-collapse{position:absolute;top:9px;left:100px}@media (min-width:992px){.navbar{height:54px;box-shadow:0 1px 3px rgba(0,0,0,.12),0 1px 2px rgba(0,0,0,.24)}.navbar .version-app{position:absolute;top:36px;left:120px;font-size:10px}.navbar .btn-collapse{position:absolute;top:9px;left:244px}}.nav-menu-buttons{margin-right:90px}`]
})
export class NavTopComponent implements OnInit {

  @Input() asideTemplate;
  @Input() templateMenuMobile;
  @Input() templateMenuDesktop;
  @Input() version: any;
  @Input() type: TYPE;
  @Output() powerClick = new EventEmitter();

  constructor() {
  }

  ngOnInit() {
  }
}
